import { CareerId } from '@common/const/catalog/career';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CityViewModel } from '@common/model/location/cityViewModel';
import { CareerDictionaryResponse } from '@cp/entities/career';
import capitalize from 'lodash/capitalize';
import { CatalogFeedbacksProps } from 'src/widgets/catalog/feedback/list/types';

export const useFeedbacksParameters = ({
  careerId,
  catalogType,
  careerDictionary,
  currentCity,
}: {
  careerId: CareerId;
  catalogType: CatalogItemType;
  careerDictionary?: CareerDictionaryResponse;
  currentCity: CityViewModel;
}): CatalogFeedbacksProps => {
  return {
    productName: careerDictionary
      ? `${capitalize(careerDictionary[careerId].translation.nameSingleGenitive)} в ${currentCity.translation.namePrepositional}`
      : undefined,
    careerId,
    catalogType,
    cityId: currentCity.id,
  };
};
